<template>
  <b-card no-body>
    <b-card-header>
      <h4>Purchase Items stock Report</h4>
    </b-card-header>
    <b-card-body>
      <b-alert
        variant="danger"
        :show="errorMessage ? true : false"
      >
        <div class="alert-body">
          <p>
            {{ errorMessage }}
          </p>
        </div>
      </b-alert>
      <b-form @submit.prevent="onSubmit">
        <b-row>
          <b-col
            md="6"
            lg="4"
            xl="3"
          >
            <b-form-group
              label="Batch stock file"
              label-for="stock-file"
            >
              <b-form-file
                id="stock-file"
                v-model="stockFile"
                placeholder="Batch stock file"
                accept=".xlsx"
              />
              <p class="field-remark">
                Stock data with only available stock with batch detail
              </p>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col
            md="6"
            lg="4"
            xl="3"
          >
            <b-form-group
              label="Invoice files"
              label-for="invoice-files"
            >
              <b-form-file
                id="invoice-files"
                v-model="invoiceFiles"
                placeholder="Invoice files"
                multiple
                accept=".csv"
              />
            </b-form-group>
            <span>OR</span>
          </b-col>
        </b-row>

        <b-row>
          <b-col
            md="6"
            lg="4"
            xl="3"
          >
            <b-button
              variant="secondary"
              class="my-2"
              size="sm"
              @click="isSeachDialogOpen = true"
            >
              <feather-icon
                icon="SearchIcon"
                class="mr-50"
              />
              Search Invoices
            </b-button>
          </b-col>
        </b-row>

        <span>
          Invoices selected : {{ selectedInvoices.length }}
        </span>

        <b-row>
          <b-col
            md="6"
            lg="4"
            xl="4"
          >
            <!-- Selected Invoices Table -->
            <div
              class="mb-3"
            >
              <b-table
                :items="selectedInvoices"
                :fields="selectedTableFields"
                responsive="sm"
                striped
                hover
                show-empty
                empty-text="No invoices selected"
                class="compact-table"
              />
            </div>
          </b-col>
        </b-row>

        <select-invoices
          v-if="isSeachDialogOpen"
          :existing-selection="selectedInvoices"
          @modal-closed="isSeachDialogOpen = false"
          @invoicesSelected="invoicesSelectionHandler"
        />

        <b-form-checkbox v-model="skipSavingVerifiedRecords">
          Skip adding verified stock report
        </b-form-checkbox>
        <b-button
          variant="primary"
          :disabled="submitting"
          type="submit"
          class="mt-2"
        >
          Submit
          <b-spinner
            v-if="submitting"
            small
            label="Small Spinner"
          />
        </b-button>
      </b-form>
    </b-card-body>
  </b-card>
</template>

<script>
import axios from 'axios'
import SelectInvoices from '@/components/Stock/VerifiedStockReport/SelectInvoices.vue'
import download from 'downloadjs'

import {
  BCard,
  BCardHeader,
  BCardBody,
  BForm,
  BRow,
  BCol,
  BFormGroup,
  BFormFile,
  BButton,
  BAlert,
  BSpinner,
  VBTooltip,
  BFormCheckbox,
  BTable,
} from 'bootstrap-vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    BFormFile,
    BButton,
    BAlert,
    BSpinner,
    BFormCheckbox,
    BTable,
    SelectInvoices,
  },
  data() {
    return {
      stockFile: null,
      invoiceFiles: [],
      selectedInvoices: [],
      submitting: false,
      errorMessage: null,
      skipSavingVerifiedRecords: false,
      isSeachDialogOpen: false,
      selectedTableFields: [
        { key: 'invoice_no', label: 'Invoice Number', sortable: false },
        { key: 'supplier__identifier', label: 'Supplier', sortable: false },
      ],
    }
  },
  watch: {
    invoiceFiles(newValue) {
      if (newValue.length) {
        this.selectedInvoices = []
      }
    },
    selectedInvoices(newValue) {
      if (newValue.length) {
        this.invoiceFiles = []
      }
    },
  },
  methods: {
    onSubmit() {
      this.submitting = true
      this.errorMessage = ''
      const formData = new FormData()
      if (this.stockFile) {
        formData.append('stock_file', this.stockFile)
      }

      if (this.invoiceFiles.length) {
        for (let x = 0; x < this.invoiceFiles.length; x += 1) {
          formData.append('invoice_files', this.invoiceFiles[x])
        }
      }

      if (this.selectedInvoices.length) {
        for (let x = 0; x < this.selectedInvoices.length; x += 1) {
          formData.append('selected_invoices', this.selectedInvoices[x].id)
        }
      }

      if (this.skipSavingVerifiedRecords) {
        formData.append('skip_saving_verified_records', this.skipSavingVerifiedRecords)
      }

      axios
        .post('/stocks/generate_stock_report/', formData, {
          responseType: 'blob',
        })
        .then(res => {
          const contentType = res.headers['content-type']
          download(res.data, 'StockReport', contentType)

          this.stockFile = null
          this.invoiceFiles = []
          this.selectedInvoices = []
          this.skipSavingVerifiedRecords = false
        })
        .catch(error => {
          error.response.data.text().then(response => {
            try {
              this.errorMessage = JSON.parse(response)?.message || 'Something went wrong'
            } catch {
              this.errorMessage = 'Something went wrong'
            }
          })
        }).finally(() => {
          this.submitting = false
        })
    },
    invoicesSelectionHandler(selectedInvoices) {
      this.selectedInvoices = [...selectedInvoices]
      this.isSeachDialogOpen = false
    },
  },
}
</script>
